// extracted by mini-css-extract-plugin
export default {"conversation":"Conversation_conversation__d-5MW","imgCont":"Conversation_imgCont__Baboc","name":"Conversation_name__Ytfhd","image":"Conversation_image__BhHgq"};